import React, { AriaRole } from "react";
import { INavLink } from "src/components/HeaderNavBar/type";
import * as styles from "./FooterNavLink.module.scss";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";
import { matchesAny } from "src/utils/localization/geolocation";

interface FooterNavLinkProps {
  link: INavLink;
  role: AriaRole;
}

const FooterNavLink: React.FC<React.PropsWithChildren<FooterNavLinkProps>> = ({
  link,
  role
}) => {
  const geolocation = useGeolocation();

  if (link.filters && link.filters.length > 0) {
    if (!matchesAny(link.filters, geolocation)) {
      return null;
    }
  }

  return (
    <a href={link.href} className={styles.navLink} role={role}>
      {link.title}
    </a>
  );
};

export default FooterNavLink;
